/* eslint-disable */
import sendRequest from "../../resources/js/utils/sendRequest";
import {qs} from "../../resources/js/utils/dom";
import '../../blocks/hero/hero';
import '../../blocks/highlighted-product/highlighted-product';

document.addEventListener('DOMContentLoaded', () => {
  const section = qs('[data-posts-grid-section-js]');
  const grid = qs('[data-posts-grid-js]');
  const loadMoreEl = qs('[data-load-more-js]');
  const maxNumPages = grid.getAttribute('data-max-num-pages-js');
  const postsPerPage = grid.getAttribute('data-posts-per-page-js');

  loadMoreEl.addEventListener('click', function () {
    let paged = +grid.getAttribute('data-paged-js');
    paged++;

    if (paged <= maxNumPages) {
      grid.setAttribute('data-paged-js', `${paged}`);

      // Insert a div.loading-posts after the page footer (avoid duplicates)
      if (!document.querySelector('.loading-posts')) {
        const footer = document.querySelector('footer');
        const loadingEl = document.createElement('div');
        loadingEl.className = 'loading-posts';
        if (footer && footer.parentNode) {
          footer.insertAdjacentElement('afterend', loadingEl);
        } else if (grid.parentElement) {
          // fallback: append to grid parent
          grid.parentElement.appendChild(loadingEl);
        }
      }

      getPosts(postsPerPage, paged).then(function (data) {
        grid.innerHTML += data.html;
        section.classList.toggle('all-loaded', data.allLoaded);
        section.classList.toggle('nothing-found', data.nothingFound);
        const existing = document.querySelector('.loading-posts');
        if (existing) existing.remove();
      });
    }
  });

  async function getPosts(postsPerPage, paged) {
    const formData = new FormData();
    formData.append('postsPerPage', postsPerPage);
    formData.append('paged', paged);

    const response = await sendRequest({method: 'POST', data: formData, endpoint: 'filter_posts'});
    const data = await response.data;

    return data;
  }
});

